import moment from 'moment-timezone';

const account = {
  screen: '',
  routeAfterLogin: 'calendar',
};

const calendar = {
  calendarPeriodLoading: false,
  calendarSpecificDate: moment(), // for expanded calendar view
  startDate: moment(),
  endDate: moment().add(1, 'months'),
};

const dirtyData = {
  alertType: 'success', // 'success' vs. 'error'
  showAlert: false,
  showModal: false,
  alertTimer: null,
  isDirty: false,
  nextRoute: '',
};

const state = {
  ...account,
  ...calendar,
  ...dirtyData,
};

export default state;
